// MuteContext.js
import { createContext, useContext, useEffect, useState } from 'react';

const MuteContext = createContext();

export const MuteProvider = ({ children }) => {
    const [isMuted, setIsMuted] = useState(() => {
        const saved = localStorage.getItem('isMuted');
        return saved !== null ? JSON.parse(saved) : true;
    });
    

    // Load initial state from localStorage
    useEffect(() => {
        const saved = localStorage.getItem('isMuted');
        if (saved !== null) {
            setIsMuted(JSON.parse(saved));
        }
    }, []);

    // Save state to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('isMuted', JSON.stringify(isMuted));
    }, [isMuted]);
    
    const toggleMute = () => setIsMuted((prev) => !prev);

    return (
        <MuteContext.Provider value={{ isMuted, toggleMute,setIsMuted  }}>
            {children}
        </MuteContext.Provider>
    );
};

export const useMute = () => useContext(MuteContext);
